// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'https://api.card4games.com/v1/',
  apiUrl: 'https://api-dev.card4games.com/v1/',
  admin_email: 'admin@admin.com',
  sentryDsn: 'https://c78c817397f5a2f34b09d3f69f458287@o4508517617303552.ingest.de.sentry.io/4508517619728464',
  sentryEnvironment: 'development',

};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
